import { lazy } from 'react';

const BookingsPage = lazy(() => import('../pages/Bookings.page'));
const AddBookingPage = lazy(() => import('../pages/AddBooking.page'));
const EditBookingPage = lazy(() => import('../pages/EditBooking.page'));

export const BookingsRoutes = [
    { path: 'bookings', element: <BookingsPage /> },
    { path: 'bookings/add', element: <AddBookingPage /> },
    { path: 'bookings/edit/:id', element: <EditBookingPage /> },
];
